export const trackMetaEvent = (eventName, payload = {}) => {
  if (typeof window === 'undefined') return;
  if (typeof window.fbq !== 'function') return;

  try {
    window.fbq('track', eventName, payload);
  } catch (error) {
    // no-op by design: analytics should never break UX
  }
};

export const trackMetaLead = (payload = {}) => {
  trackMetaEvent('Lead', payload);
};

export const trackMetaContact = (payload = {}) => {
  trackMetaEvent('Contact', payload);
};
